export const WizardEvents = {
    wizardChange: "wizard-change",
    wizardComplete: "wizard-complete"
};
//# sourceMappingURL=wizard.options.js.map